module.exports = __webpack_public_path__ + "static/header_background-e9a899e6a15197b74400e897cd65caa9.png";